module.exports = "https://zappar-media.s3.eu-west-1.amazonaws.com/draw1.zpt"